import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useLanguage } from '../../../context/LanguageContext';
import './TreatmentInfo.css';

const TreatmentInfo: React.FC = () => {
  const { t } = useLanguage();

  return (
    <section id="treatment-info" className="treatment-info-section py-5">
      <Container>
        {/* Section Title - Centered */}
        <Row className="mb-5">
          <Col className="text-center">
            <div className="luxury-title-container">
              <h2 className="luxury-section-title">{t('treatment.title')}</h2>
              <div className="luxury-underline mx-auto"></div>
            </div>
          </Col>
        </Row>
        
        {/* Content Row - Equal Height */}
        <Row className="align-items-stretch">
          <Col lg={6} className="mb-4 mb-lg-0 order-2 order-lg-1 mt-3 mt-lg-0">
            <div className="treatment-info-content h-100">
              <div className="typography-content h-100 d-flex flex-column">
                <p className="lead-text">
                  {t('treatment.description')}
                </p>
                
                <div className="treatment-approach">
                  <h4>{t('treatment.approach.title')}</h4>
                  <p>
                    {t('treatment.approach.description')}
                  </p>
                  <ul>
                    <li>{t('treatment.approach.item1')}</li>
                    <li>{t('treatment.approach.item2')}</li>
                    <li>{t('treatment.approach.item3')}</li>
                    <li>{t('treatment.approach.item4')}</li>
                  </ul>
                </div>
                
                <div className="expert-note mt-auto">
                  <h4>{t('treatment.expert.title')}</h4>
                  <p>
                    {t('treatment.expert.description')}
                  </p>
                </div>
              </div>
            </div>
          </Col>
          
          <Col lg={6} className="order-1 order-lg-2">
            <div className="treatment-info-image h-100">
              <img 
                src="assets/img/kepce-kulak-ameliyati.webp.png" 
                alt="Kepçe Kulak Tedavisi" 
                className="img-fluid rounded h-100"
                style={{objectFit: 'cover'}}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default TreatmentInfo;
